import { render } from "./base-search.vue?vue&type=template&id=6e9704f5&ts=true"
import script from "./base-search.vue?vue&type=script&lang=ts"
export * from "./base-search.vue?vue&type=script&lang=ts"

import "./base-search.vue?vue&type=style&index=0&id=6e9704f5&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__